import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { applyTheme, loadTheme } from './lib/theme';
import './styles/global.css';

// Aplica o tema antes do primeiro render, para nao piscar branco no escuro.
applyTheme(loadTheme());

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root nao encontrado.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
